const Chai = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Chai-1.jpg"
				alt="Chai"
			/>
		</div>
	);
};

export default Chai;
